import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import StaticContainer from 'react-static-container';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';

// eslint-disable-line no-unused-vars

export class MerchantMarketing extends Component {
    static defaultProps = {
        automationId: '',
        productDetails: {},
        filteredItems: {},
    };

    static propTypes = {
        automationId: PropTypes.string,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        filteredItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    };

    constructor() {
        super();
        this.onWebCollageLoad = this.onWebCollageLoad.bind(this);
        this.containerRef = React.createRef();
        this.state = {
            isExpanded: false,
            contentLoaded: false,
        };
    }

    componentDidMount() {
        const webCollageScript = {
            src: '//scontent.webcollage.net/api/v2/product-content',
            onSuccess: this.onWebCollageLoad,
            defer: false,
        };
        ScriptLoader.load(webCollageScript);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.filteredItems !== this.props.filteredItems) {
            this.onWebCollageLoad();
        }
    }

    onWebCollageLoad = () => {
        window.Webcollage &&
            window.Webcollage.loadContent(
                'jcpenney-mobile',
                this.props.productDetails.id,
                {
                    reload: true,
                },
                (contentLoaded) => {
                    contentLoaded && this.setContentLoaded();
                }
            ); // eslint-disable-line no-undef
    };

    powerPageViewHandler = () => {
        this.setState(
            (prevState) => ({
                isExpanded: !prevState.isExpanded,
            }),
            () => {
                !this.state?.isExpanded &&
                    this.containerRef?.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'nearest',
                    });
            }
        );
    };

    setContentLoaded = () => {
        this.setState({ contentLoaded: true });
    };

    render() {
        const gradientStyles = [
            'before:bg-gradient-to-b',
            'before:from-transparent',
            'before:to-white',
        ];
        const showMoreStyles = [
            'lg:max-h-[692px]',
            'md:max-h-[492px]',
            'sm:max-h-[292px]',
            'overflow-hidden',
            'before:left-0',
            'before:z-[7]',
            'before:absolute',
            'before:w-full',
            'before:h-20',
            'before:bottom-0',
            'relative',
        ];
        const stylesToRender = !this.state.isExpanded
            ? [...showMoreStyles, ...gradientStyles]
            : [''];
        const mbStyle = this.state?.contentLoaded ? ['mb-10'] : [''];
        return (
            <>
                <div className={dt([...stylesToRender])}>
                    <StaticContainer>
                        <div
                            id="wc-power-page"
                            data-automation-id={this.props.automationId}
                            ref={this.containerRef}
                        />
                    </StaticContainer>
                </div>
                {this.state?.contentLoaded ? (
                    <div
                        className={dt([
                            'pt-[18px]',
                            'flex',
                            'justify-center',
                            'items-center',
                            ...mbStyle,
                        ])}
                    >
                        <Button
                            automationId="at-wc-power-page-cta"
                            className={dt(['w-auto'])}
                            onClick={this.powerPageViewHandler}
                            id="wc-power-page-cta"
                            buttonType="Secondary"
                            size="Md"
                            type="button"
                        >
                            {this.state.isExpanded ? 'Show Less' : 'Show More'}
                        </Button>
                    </div>
                ) : null}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    filteredItems: initProductOptions(false)(state).filteredItems,
});

export default connect(mapStateToProps)(MerchantMarketing);
